import { useEffect, useState } from "react";

/** Presentation only: never use this to authorize native capabilities. */
export function isInstalledApp(): boolean {
  return Boolean(
    window.DerechLocation || window.DerechCar ||
    /Desty(?:Android|iOS)\//.test(navigator.userAgent) ||
    (navigator as Navigator & { standalone?: boolean }).standalone ||
    window.matchMedia?.("(display-mode: standalone)").matches,
  );
}

export function useInstalledApp(): boolean {
  const [installed, setInstalled] = useState(isInstalledApp);
  useEffect(() => {
    const refresh = () => setInstalled(isInstalledApp());
    const media = window.matchMedia?.("(display-mode: standalone)");
    window.addEventListener("derech:car-ready", refresh);
    media?.addEventListener?.("change", refresh);
    refresh(); // Older hosts inject their bridge after the document has loaded.
    return () => {
      window.removeEventListener("derech:car-ready", refresh);
      media?.removeEventListener?.("change", refresh);
    };
  }, []);
  return installed;
}
